import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Select,
  MenuItem,
  Button,
  Stack,
  Paper,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
const numbers = Array.from({ length: 10 }, (_, i) => i.toString());

const CharacterListSelector = ({ field, value, onChange }) => {
  const handleAdd = () => {
    onChange([...value, { type: "letter", char: "A" }]);
  };

  const handleChange = (index, key, val) => {
    const updated = [...value];
    updated[index][key] = val;

    // reset char to default if type changes
    if (key === "type") {
      updated[index].char = val === "number" ? "0" : "A";
    }

    onChange(updated);
  };

  const handleRemove = (index) => {
    const updated = [...value];
    updated.splice(index, 1);
    onChange(updated);
  };

  const summary = value.map((v) => v.char).join("");

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 3,
        borderRadius: 2,
        backgroundColor: "#fcfcfc",
        mt: 3,
      }}>
      <Typography variant="subtitle1" fontWeight={600} gutterBottom>
        {field.label}
      </Typography>

      {field.warning && (
        <Typography
          variant="caption"
          color="warning.main"
          sx={{ display: "block", mb: 2 }}>
          ⚠️ {field.warning}
        </Typography>
      )}

      <Stack spacing={2} sx={{ mb: 2 }}>
        {value.map((entry, i) => (
          <Box
            key={i}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              flexWrap: "wrap",
            }}>
            <Select
              size="small"
              value={entry.type}
              onChange={(e) => handleChange(i, "type", e.target.value)}
              displayEmpty
              sx={{ minWidth: 140 }}>
              <MenuItem value="">Select Type</MenuItem>
              <MenuItem value="letter">Letter</MenuItem>
              <MenuItem value="number">Number</MenuItem>
            </Select>

            <Select
              size="small"
              value={entry.char}
              onChange={(e) => handleChange(i, "char", e.target.value)}
              displayEmpty
              disabled={!entry.type}
              MenuProps={{
                PaperProps: { style: { maxHeight: 300 } },
              }}
              sx={{ minWidth: 140 }}>
              <MenuItem value="">Select Value</MenuItem>
              {(entry.type === "letter" ? alphabet : numbers).map((opt) => (
                <MenuItem key={opt} value={opt}>
                  {opt}
                </MenuItem>
              ))}
            </Select>

            <IconButton onClick={() => handleRemove(i)} size="small">
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Box>
        ))}
      </Stack>

      <Button
        onClick={handleAdd}
        variant="outlined"
        size="small"
        sx={{
          borderColor: "#fd7762",
          color: "#fd7762",
          textTransform: "none",
          fontWeight: 600,
          "&:hover": {
            backgroundColor: "#fff0ee",
            borderColor: "#fd7762",
          },
        }}>
        + Add Character
      </Button>

      {summary && (
        <Typography
          variant="body2"
          sx={{ mt: 3, fontStyle: "italic", color: "text.secondary" }}>
          Current Selection: <strong>{summary}</strong>
        </Typography>
      )}
    </Paper>
  );
};

export default CharacterListSelector;
